import React from 'react';
import Header from '../components/Header';
import FooterSection from '../components/FooterSection';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Header selectedTab="" onTabChange={() => {}} />
      
      <main className="flex-grow px-6 py-24 max-w-screen-md mx-auto text-right" dir="rtl">
        <h1 className="text-4xl font-extrabold mb-8">درباره ما</h1>

        <p className="text-lg leading-relaxed mb-6 text-neutral-300">
          شرکت دانش پردازش پیشرو تک (DPTEK) یک شرکت پیشرو در حوزه فناوری‌های نوظهور و عمیق (Deep Tech) است که با هدف ساده‌سازی پیچیدگی‌ها و افزایش بهره‌وری از طریق هوش مصنوعی تأسیس شده است.
        </p>

        <p className="text-lg leading-relaxed mb-6 text-neutral-300">
          ما در شرکت دانش پردازش پیشرو تک به این باور داریم که آینده به سمت یکپارچه‌سازی هوش مصنوعی در زندگی روزمره و فرآیندهای شغلی حرکت می‌کند. به همین دلیل، تمرکز ما بر ارائه‌ی ابزارها و راهکارهایی است که کاربران را قادر می‌سازد با هوش مصنوعی، پروژه‌ها، آموزش‌ها و کسب‌وکار خود را متحول کنند.
        </p>

        <p className="text-lg leading-relaxed mb-6 text-neutral-300">
          خدمات ما شامل توسعه دستیارهای هوش مصنوعی، سیستم‌های گفت‌وگو محور، ابزارهای متن به صوت، تولید تصویر، و پلتفرم‌های افزونه‌محور است. ما همواره تلاش می‌کنیم تجربه‌ای ساده، لذت‌بخش و کاربردی را برای کاربران خود فراهم کنیم.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">ماموریت ما</h2>
        <p className="text-lg leading-relaxed mb-6 text-neutral-300">
          خلق بستری که در آن هر فرد یا سازمان بتواند به آسانی از قدرت هوش مصنوعی برای حل چالش‌های واقعی خود استفاده کند. ما به دنبال دموکراتیزه کردن فناوری هستیم.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">چشم‌انداز ما</h2>
        <p className="text-lg leading-relaxed mb-6 text-neutral-300">
          تبدیل‌شدن به یکی از تأثیرگذارترین برندها در زمینه هوش مصنوعی خاورمیانه تا سال ۲۰۳۰ و همکاری با متخصصان، توسعه‌دهندگان و سازمان‌ها در جهت ساخت آینده‌ای هوشمندتر.
        </p>
      </main>

      <FooterSection />
    </div>
  );
};

export default AboutPage;
